import { CSS_DANGEROUS_PATTERNS, JS_DANGEROUS_PATTERNS, XSS_PATTERNS } from '@/constants/common';

export interface SecurityViolation {
  type: 'xss' | 'css' | 'js';
  pattern: RegExp;
  match: string;
  line?: number;
  column?: number;
}

export const checkXSSPatterns = (content: string): SecurityViolation[] => {
  const violations: SecurityViolation[] = [];

  XSS_PATTERNS.forEach((pattern) => {
    const matches = content.match(pattern);
    if (matches) {
      matches.forEach((match) => {
        violations.push({
          type: 'xss',
          pattern,
          match,
          line: getLineNumber(content, match),
          column: getColumnNumber(content, match),
        });
      });
    }
  });

  return violations;
};

export const checkCSSDangerousPatterns = (content: string): SecurityViolation[] => {
  const violations: SecurityViolation[] = [];

  CSS_DANGEROUS_PATTERNS.forEach((pattern) => {
    const matches = content.match(pattern);
    if (matches) {
      matches.forEach((match) => {
        violations.push({
          type: 'css',
          pattern,
          match,
          line: getLineNumber(content, match),
          column: getColumnNumber(content, match),
        });
      });
    }
  });

  return violations;
};

export const checkJSDangerousPatterns = (content: string): SecurityViolation[] => {
  const violations: SecurityViolation[] = [];

  JS_DANGEROUS_PATTERNS.forEach((pattern) => {
    const matches = content.match(pattern);
    if (matches) {
      matches.forEach((match) => {
        violations.push({
          type: 'js',
          pattern,
          match,
          line: getLineNumber(content, match),
          column: getColumnNumber(content, match),
        });
      });
    }
  });

  return violations;
};

export const performSecurityCheck = (
  content: string,
  fileType: 'html' | 'css' | 'js'
): SecurityViolation[] => {
  const violations: SecurityViolation[] = [];

  violations.push(...checkXSSPatterns(content));

  switch (fileType) {
    case 'css':
      violations.push(...checkCSSDangerousPatterns(content));
      break;
    case 'js':
      violations.push(...checkJSDangerousPatterns(content));
      break;
    case 'html':
      violations.push(...checkCSSDangerousPatterns(content));
      violations.push(...checkJSDangerousPatterns(content));
      break;
  }

  return violations;
};

export const sanitizeContent = (content: string, fileType: 'html' | 'css' | 'js'): string => {
  let sanitized = content;

  XSS_PATTERNS.forEach((pattern) => {
    sanitized = sanitized.replace(pattern, '');
  });

  switch (fileType) {
    case 'css':
      CSS_DANGEROUS_PATTERNS.forEach((pattern) => {
        sanitized = sanitized.replace(pattern, '');
      });
      break;
    case 'js':
      JS_DANGEROUS_PATTERNS.forEach((pattern) => {
        sanitized = sanitized.replace(pattern, '');
      });
      break;
    case 'html':
      CSS_DANGEROUS_PATTERNS.forEach((pattern) => {
        sanitized = sanitized.replace(pattern, '');
      });
      JS_DANGEROUS_PATTERNS.forEach((pattern) => {
        sanitized = sanitized.replace(pattern, '');
      });
      break;
  }

  return sanitized;
};

const getLineNumber = (content: string, match: string): number => {
  const lines = content.split('\n');
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes(match)) {
      return i + 1;
    }
  }
  return 1;
};

const getColumnNumber = (content: string, match: string): number => {
  const index = content.indexOf(match);
  if (index === -1) return 1;

  const beforeMatch = content.substring(0, index);
  const lastNewline = beforeMatch.lastIndexOf('\n');
  return lastNewline === -1 ? index + 1 : index - lastNewline;
};
